<div class="popover">
	<img class="themified-white-icon icon-popover" src="/assets/icons/info-icon.png" (click)="togglePopover()">
	<div class="popover-container" [hidden]="!isPopoverOpened">
		<div class="popover-content">
			<div class="popover-text">
				<ng-content></ng-content>
        <ng-content select="small-text"></ng-content>
			</div>
		</div>
	</div>
</div>
